import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.js';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { style } from '@vanilla-extract/css';

export const splashScreen = style({
  position: 'fixed',
  inset: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: themeVars.base.background,
});

export const splashScreenLogo = style([
  {
    color: themeVars.button.inverted.foreground,
  },
  responsiveStyle({
    mobile: { width: 122 },
    laptop: { width: 142 },
  }),
]);
